<script>
import Layout from '@layouts/default'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import CryptoJS from 'crypto-js'
import {
  getFirestore,
  collection,
  updateDoc,
  serverTimestamp,
  doc,
} from 'firebase/firestore/lite'
import { firebase } from '../../../../firebase-int'

const firestore = getFirestore(firebase)
/**
 * Login component
 */
export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
  },
  components: { Layout },
  data() {
    return {
      username: this.$store.state.auth.dummyUsername,
      password: this.$store.state.auth.dummyPassword,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      secret: '123#$%',
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            username: 'Use "admin" to log in with the mock API',
            password: 'Use "password" to log in with the mock API',
          }
    },
  },
  methods: {
    ...authMethods,
    // Try to log the user in with the username
    // and password they provided.
    // encryption related methods
    encryptData(passwordData) {
      // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
      return CryptoJS.AES.encrypt(passwordData, this.secret).toString()
    },

    tryToLogIn() {
      this.tryingToLogIn = true
      // Reset the authError if it existed.
      this.authError = null
      this.isAuthError = false
      return this.logIn({
        username: this.username,
        password: this.password,
      })
        .then(async (user) => {
          this.tryingToLogIn = false
          this.isAuthError = false
          // Redirect to the originally requested page, or to the home page
          // console.log('>>>>>>>>>>> Successful Login: '+user.id)
          await this.saveLastLoginDate(user)
          if (!user.isVerified) {
            console.log('>>>>>>>>>>>> Please verify your account first') //go to verification page
            this.$router.push({ name: 'verify', params: { user: user } })
          } //if verified
          else {
            if (!user.dataComplete) {
              //if data is not Complete
              console.log('>>>>>>>>>>>> Please complete user data') //go to member edit page with the user instance
              this.$router.push({
                name: 'Edit Member Once',
                params: { member: user },
              })
            } //login
            else {
              if(!user.chapters)
              user.chapters=[]
              if(!user.progress)
              user.progress=[]
              /* console.log('>>>>>>>>>>> Redirect from - ' + this.$route.query.redirectFrom)
              //avoid it going to lougout again
              if(this.$route.query.redirectFrom)
              if(this.$route.query.redirectFrom.includes('logout'))
              this.$router.push(
                  { name: 'Dashboard' }
                )
                else
              this.$router.push(
                  this.$route.query.redirectFrom || { name: 'Dashboard' }
                ) */

                this.$router.push(
                  { name: 'Dashboard' })
              // if (user.accessLevel == 'Administrator')
              //   this.$router.push(
              //     this.$route.query.redirectFrom || { name: 'Dashboard' }
              //   )
              // else if (user.accessLevel == 'User')
              //   this.$router.push(
              //     this.$route.query.redirectFrom || { name: 'User Dashboard' }
              //   )
              // else if (user.accessLevel == 'Union Administrator')
              //   this.$router.push(
              //     this.$route.query.redirectFrom || { name: 'Union Dashboard' }
              //   )
              // else if (user.accessLevel == 'Federation Administrator')
              //   this.$router.push(
              //     this.$route.query.redirectFrom || { name: 'Federation Dashboard' }
              //   )
              // else
              //   this.$router.push(
              //     this.$route.query.redirectFrom || { name: 'Editor Dashboard' }
              //   )
            }
          }
        })
        .catch((error) => {
          this.tryingToLogIn = false
          this.authError = error.response
            ? error.response.data.message
            : 'Connection problem. Please try again.'
          this.isAuthError = true
        })
    },
    async saveLastLoginDate(user) {
      const docRef = doc(firestore, 'member', user.id)
      var previousLoginDate=null
      //console.log('>>>>>>>>>>>>> Last Login Date: ',user.lastLogin)
        if(user.lastLogin)
        {
          //console.log('>>>>>>>>>>>>> Last Login Date: ',user.lastLogin)
        previousLoginDate=user.lastLogin

        }
      await updateDoc(docRef, {
        previousLoginDate:previousLoginDate,
        lastLogin: serverTimestamp(),
      })
    },


    getLoginLabel()
    {
      if(this.tryingToLogIn)
      return this.$i18n.t('page.login.logingIn')
      else
      return this.$i18n.t('page.login.login')
    },
    getStyle()
      {
        if(this.$i18n.locale=='am')
        return 'lighterTextAm'
        else
        return 'lighterTextEn'
      }
    
  },
}
</script>

<template>
  <Layout>
    <!-- end row -->
    <div class="account-pages my-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-10">
            <div class="card">
              <div class="card-body p-0">
                <div class="row">
                  <div class="col-md-6 p-5">
                    <div class="mx-auto mb-5">
                      <a routerLink="/">
                        <img src="@assets/images/logo.png" alt height="24" />
                        <h3 class="d-inline align-middle ml-1 text-logo"
                          >{{ $t("app.name") }}</h3
                        >
                      </a>
                    </div>

                    <h6 class="h5 mb-0 mt-4"
                      >{{ $t("page.login.welcomeMessage") }}</h6
                    >
                    <p class="text-muted mt-1 mb-4">
                      {{ $t("page.login.enterDetails") }}
                    </p>

                    <b-alert
                      v-model="isAuthError"
                      variant="danger"
                      dismissible
                      >{{ authError }}</b-alert
                    >

                    <b-form
                      class="authentication-form"
                      @submit.prevent="tryToLogIn"
                    >
                      <div class="form-group">
                        <label class="form-control-label" :class="getStyle()">{{ $t("page.login.phone") }}</label>
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather
                                type="phone"
                                class="align-middle icon-dual"
                              ></feather>
                            </span>
                          </div>
                          <b-form-input
                            id="input-1"
                            v-model="username"
                            type="text"
                            required
                            :placeholder="$t('page.login.enterPhone')"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="form-group mt-4">
                        <label class="form-control-label" :class="getStyle()">{{ $t("page.login.password") }}</label>
                        <router-link
                          to="forget-password"
                          class="float-right text-muted text-unline-dashed ml-1"
                          >{{ $t("page.login.forgotPassword") }}</router-link
                        >
                        <div class="input-group input-group-merge">
                          <div class="input-group-prepend">
                            <span class="input-group-text">
                              <feather
                                type="lock"
                                class="align-middle icon-dual"
                              ></feather>
                            </span>
                          </div>
                          <b-form-input
                            id="password"
                            v-model="password"
                            type="password"
                            required
                            :placeholder="$t('page.login.enterPassword')"
                          ></b-form-input>
                        </div>
                      </div>
                      <div class="form-group mb-4">
                        <div class="custom-control custom-checkbox">
                          <input
                            id="checkbox-signin"
                            type="checkbox"
                            class="custom-control-input"
                            checked
                          />
                          <label
                            class="custom-control-label" :class="getStyle()"
                            for="checkbox-signin"
                          >
                            {{ $t("page.login.rememberMe") }}
                          </label>
                        </div>
                      </div>
                      <b-form-group id="button-group" class="mt-4 mb-1">
                        <b-button
                          type="submit"
                          variant="primary"
                          class="btn-block"
                          :disabled="tryingToLogIn"
                          >{{getLoginLabel()}}</b-button
                        >
                      </b-form-group>
                    </b-form>
                    <!--div class="py-3 text-center">
											<span class="font-size-16 font-weight-bold">Or</span>
										</div-->
                    <!--div class="row">
											<div class="col-6">
												<a href="javascript: void(0);" class="btn btn-white">
													<i class="uil uil-google icon-google mr-2"></i>With
													Google
												</a>
											</div>
											<div class="col-6 text-right">
												<a href="javascript: void(0);" class="btn btn-white">
													<i class="uil uil-facebook mr-2 icon-fb"></i>With
													Facebook
												</a>
											</div>
										</div-->
                  </div>
                  <div class="col-lg-6 d-none d-md-inline-block">
                    <div class="auth-page-sidebar">
                      <!--div class="overlay"></div-->
                      <div class="auth-user-testimonial">
                        <!--p class="font-size-24 font-weight-bold text-white mb-1"
													>I simply love it!</p
												>
												<p class="lead"
													>"It's a elegent templete. I love it very much!"</p
												>
												<p>- Admin User</p-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->

            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted" :class="getStyle()">
                  {{ $t("page.login.dontHaveAccount") }}
                  <!--router-link
                    tag="a"
                    to="/register"
                    class="text-primary ml-1" :class="getStyle()"
                  >
                    {{ $t("page.login.signUp") }}
                  </router-link-->
                  <router-link :to="{ name: 'register' }" class="text-primary font-weight-bold ml-1" :class="getStyle()">{{ $t("page.login.signUp") }}</router-link>
                  <!-- <a
                    routerLink="/account/signup"
                    class="text-primary font-weight-bold ml-1"
                  >Sign Up</a>-->
                </p>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </div>
  </Layout>
</template>


<style scoped>
.btn{
  font-size: 1rem;
}
.lighterTextAm{
  font-weight: 300 !important;
  font-size: 1.0rem !important;
}
.lighterTextEn{
  font-weight: 300 !important;
  font-size: 0.875rem !important;
}
</style>
